import { ArrowRight, LockKeyhole } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import BrandLogo from "../components/BrandLogo";
import { NoIndex } from "../components/SeoMetadata";
import api, { formatApiError } from "../lib/api";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/oversikt");
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setLoading(false);
    }
  };

  return <main className="admin-login" data-testid="admin-login-page"><NoIndex /><a href="/" data-testid="login-home-link"><BrandLogo /></a><form data-testid="admin-login-form" onSubmit={submit}><span className="login-icon"><LockKeyhole size={20} /></span><p className="section-eyebrow">Administrasjon</p><h1>Velkommen tilbake.</h1><label>E-post<input data-testid="login-email-input" required type="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label><label>Passord<input data-testid="login-password-input" required type="password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>{error && <p className="form-status form-status--error" data-testid="login-error">{error}</p>}<button className="button button--light" data-testid="login-submit-button" disabled={loading} type="submit">{loading ? "Logger inn..." : "Logg inn"}<ArrowRight size={17} /></button></form></main>;
}